module.exports = __webpack_public_path__ + "assets/media/video2.80250931.mp4";